import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
  title: string;
  subtitle?: string;
}
export function Layout({
  children,
  currentPage,
  onNavigate,
  title,
  subtitle
}: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-122">
      <div className="hidden lg:block flex-shrink-0 w-64" data-id="element-123">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} isOpen={true} onToggle={() => setSidebarOpen(false)} data-id="element-124" />
      </div>
      <div className="lg:hidden" data-id="element-125">
        <Sidebar currentPage={currentPage} onNavigate={onNavigate} isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-126" />
      </div>
      <div className="flex-1 flex flex-col min-h-screen min-w-0" data-id="element-127">
        <Header title={title} subtitle={subtitle} onNavigate={onNavigate} data-id="element-128" />
        <main className="flex-1 p-4 lg:p-8 overflow-auto" data-id="element-129">{children}</main>
      </div>
    </div>;
}